export const CONTINUOUS_PADDING_PIXELS = 24;

export const DRAGGABLE_ITEM_TYPE = 'bubbles';
